module.exports = __webpack_public_path__ + "img/claimable.4631970a.svg";